import { CustomHighchartsTooltip, TooltipHeader, TooltipBody } from '../../highcharts/options/customTooltipStyles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const GaugeTooltip = ({
  dataValue,
  dataValueLabel
}) => {
  return /*#__PURE__*/_jsxs(CustomHighchartsTooltip, {
    children: [/*#__PURE__*/_jsx(TooltipHeader, {
      children: dataValueLabel
    }), /*#__PURE__*/_jsx(TooltipBody, {
      children: dataValue
    })]
  });
};